import _ from 'lodash'
import { CATEGORIES } from 'components/setupform-form/field/event-type-selector/event-type-selector-container'

export const getCategoryTypes = state => _.groupBy(state.entities.eventTypes, 'category')
export const getCategoryName = eventTypeId => (state) => {
  const category = state.entities.eventTypes && state.entities.eventTypes[eventTypeId]
  if (category) {
    const categoryObject = CATEGORIES.find(c => c.key === category.category)
    const humanReadableCategory = (categoryObject && categoryObject.name) || category.category
    return category && (`${humanReadableCategory} - ${category.title}`)
  }
  return undefined
}
export const getDeal = dealId => state => state.entities.deals[dealId]
export const getDeals = state => state.entities.deals
export const getEventGroup = eventGroupId => state => state.entities.eventGroups[eventGroupId]
export const getEventGroups = state => state.entities.eventGroups
export const getEventTypes = state => state.entities.eventTypes
export const getGroups = state => state.entities.groups
export const getMarket = marketId => state => state.entities.markets[marketId]
export const getMarkets = state => state.entities.markets
export const getPartner = partnerId => state => state.entities.partners[partnerId]
export const getPartnerPermissions = partnerId => state => state.entities.partnerSettings[partnerId].permissions
export const getPerformance = performanceId => state => state.entities.performances[performanceId]
export const getPerformances = state => state.entities.performances
export const getPromoCode = promoCodeId => state => state.entities.promoCodes[promoCodeId]
export const getPromoCodes = state => state.entities.promoCodes
export const getSellableItem = sellableItemId => state => state.entities.sellableItems[sellableItemId]
export const getSellableItems = state => state.entities.sellableItems
export const getSetupform = setupformId => state => state.entities.setupforms[setupformId]
export const getSetupforms = state => state.entities.setupforms
export const getTickets = state => state.entities.tickets
export const getVenue = venueId => state => state.entities.venues[venueId]
export const getVenues = state => state.entities.venues



/** WEBPACK FOOTER **
 ** ./src/selectors/entities/entities-selectors.js
 **/